import { Routes } from '@angular/router';
import { adminGuard, authGuard } from "../../_shared/helpers";
import { PpsComponent } from "./pps/pps.component";
import { ImpressumComponent } from "../impressum/impressum.component";
import {SettingsComponent} from "../settings/settings.component";
import {MaterialComponent} from "../settings/material/material.component";
import {ConditionsComponent} from "../settings/conditions/conditions.component";
import { StaffComponent } from "../settings/staff/staff.component";

export const DASHBOARD_ROUTES: Routes = [
  {
    path: 'dashboard',
    pathMatch: 'full',
    redirectTo: 'dashboard/pps',
  },
  {
    path: 'impressum',
    component: ImpressumComponent,
    canActivate: [authGuard]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'conditions/overview',
    component: ConditionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'material/overview',
    component: MaterialComponent,
    canActivate: [authGuard]
  },
  {
    path: 'staff/overview',
    component: StaffComponent,
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'impressum',
    component: ImpressumComponent,
    canActivate: [authGuard]
  },
  {
    path: 'dashboard/pps',
    component: PpsComponent,
    canActivate: [authGuard]
  },
];
